import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  QueryFormColumn,
  QueryFormData,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { RGBAColor } from '../../types';


export type EchartsGaugeFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric?: string;
    showLabels: boolean;
    rowLimit: number;
    valueFormat: string;
    stageColor1: RGBAColor;
    stageColor2: RGBAColor;
    stageColor3: RGBAColor;
    threshold1: string;
    threshold2: string;
    rangeMin: string;
    rangeMax: string;
};

export interface EchartsGaugeChartProps
  extends ChartProps<EchartsGaugeFormData> {
  formData: EchartsGaugeFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsGaugeFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  rowLimit: 10,
  valueFormat: '{value} km/h',
  stageColor1: { r: 103, g: 224, b: 227, a: 1 },
  stageColor2: { r: 55, g: 162, b: 218, a: 1 },
  stageColor3: { r: 253, g: 102, b: 109, a: 1 },
  threshold1: '30',
  threshold2: '70',
  rangeMin: '0',
  rangeMax: '100',
};

export interface GaugeChartTransformedProps {
  formData: EchartsGaugeFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  // labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}